import { render, staticRenderFns } from "./PopupBannerDisplayOption.vue?vue&type=template&id=00ebc1f2&"
import script from "./PopupBannerDisplayOption.vue?vue&type=script&lang=ts&"
export * from "./PopupBannerDisplayOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports